<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [showCreate]="false"
   [hideHeader]="hideHeader"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="phoneType" width="4">
            <th lcs-header-cell *lcsHeaderCellDef id="active-column-header">Phone Type</th>
            <td lcs-cell *lcsCellDef="let phone">
               <a [routerLink]="getRouterLink(phone.phoneId)">
                  {{ phone.phoneType }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="name" width="8">
            <th lcs-header-cell *lcsHeaderCellDef id="phoneid-column-header">Name</th>
            <td lcs-cell *lcsCellDef="let phone">
               <a [routerLink]="getRouterLink(phone.phoneId)">
                  {{ phone.name }}
               </a>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
